import React from 'react';
import { FlexboxGrid } from 'rsuite';
import { PeriodType, DatePeriod } from '@/types/primaryLedgerSnapshots';
import PeriodTypeSelector from './PeriodTypeSelector';
import PeriodNavigator from './PeriodNavigator';
import PeriodJumpSelector from './PeriodJumpSelector';

interface PeriodSelectorProps {
  periodType: PeriodType;
  period: DatePeriod;
  onPeriodTypeChange: (type: PeriodType) => void;
  onNavigate: (direction: 'previous' | 'next') => void;
  onCurrent: () => void;
  onJump: (date: Date) => void;
}

const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  periodType,
  period,
  onPeriodTypeChange,
  onNavigate,
  onCurrent,
  onJump
}) => {
  return (
    <div className="mb-6">
      <FlexboxGrid>
        <FlexboxGrid.Item colspan={24}>
          <PeriodTypeSelector
            value={periodType}
            onChange={onPeriodTypeChange}
          />
        </FlexboxGrid.Item>
      </FlexboxGrid>
      
      <FlexboxGrid justify="space-between" align="middle" className="mt-4">
        <FlexboxGrid.Item>
          <PeriodNavigator
            period={period}
            onNavigate={onNavigate}
            onCurrent={onCurrent}
          />
        </FlexboxGrid.Item>
        
        <FlexboxGrid.Item>
          <PeriodJumpSelector
            periodType={periodType}
            period={period}
            onJump={onJump}
          />
        </FlexboxGrid.Item>
      </FlexboxGrid>
    </div>
  );
};

export default PeriodSelector;